import { observer } from 'mobx-react';
import * as React from 'react';
import ConfirmModal, { Props } from './ConfirmModal';

const Confirm: React.FC<Props> = (props) => <ConfirmModal {...props} />;

export default observer(Confirm);
